// import mixins from './../_mixins-missmatch-monitor';
import methods from './_methods';
import mounted from './_mounted';
import mixins from './../_mixins-missmatch-monitor';

export default {
    name: 'TableLastMovements',
    mixins: [mixins],
    mounted,
    methods,
    watch: {
        checksActivated(val) {
            if (!val) {
                this.checks = [];
            }
        }
    },
    data() {
        return {
            loading: true,
            lastOperations: [],
            checks: []
        };
    },
    props: {
        account: {
            type: String,
            required: true
        },
        productSelected: {
            type: Object,
            required: true
        },
        checksActivated: {
            type: Boolean
        }
    },
    computed: {
        fields() {
            return [
                'id_object',
                'operation_status',
                'operation_date',
                'interveners',
                'gross_amount',
                'net_amount',
                'name_product',
                'key_operation_type',
                'nav',
                'shares'
            ];
        }
    }
};
